module.exports = __webpack_public_path__ + "static/img/img-aboutus-03.ba6131d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/img-aboutus-03.png
// module id = FnkK
// module chunks = 1